const MONGO_FILTER_LABELS = {
  categoriaPredefinita: "Categoria web predefinita",
  categorieWeb: "Categorie web",
  persona: "Persona (Mongo)",
  stagioneCollezione: "Stagione/collezione",
  stagioneConsigliata: "Stagione consigliata",
  utilizzo: "Utilizzo",
  attivoSuEcom: "Attivo su e-commerce",
  exportAmazon: "Export Amazon",
  continuativo: "Continuativo",
  metodoSpedizione: "Metodo spedizione",
  personalizzato: "Articolo personalizzato",
  alwaysOn: "Always on",
};

const flattenCampiRicerca = (campiRicerca = []) =>
  (campiRicerca || []).flatMap((group) =>
    (group || []).filter((field) => field?.nome && field?.label),
  );

const cleanFilterKey = (key = "") =>
  String(key)
    .replace(/^[a-z]+\./i, "")
    .replace(/`/g, "")
    .replace(/\s+(LIKE|IN|IS|=|>=|<=)$/i, "")
    .trim();

const getFieldMap = (campiRicerca = []) => {
  const map = new Map();
  flattenCampiRicerca(campiRicerca).forEach((field) => {
    map.set(field.nome, field);
  });
  return map;
};

const formatFieldValue = (field, rawValue) => {
  if (rawValue === null || rawValue === undefined || rawValue === "") {
    return "";
  }

  if (Array.isArray(rawValue)) {
    return rawValue.join(", ");
  }

  const value = String(rawValue);
  const exactMatch = Array.isArray(field?.dati)
    ? field.dati.find((item) => String(item?.value) === value)
    : null;
  if (exactMatch?.desc) {
    return exactMatch.desc;
  }

  if (
    Array.isArray(field?.dati) &&
    value.includes(",") &&
    field.tipo === "tendinaDati"
  ) {
    const joinedMatch = field.dati.find((item) => String(item?.value) === value);
    if (joinedMatch?.desc) {
      return joinedMatch.desc;
    }
  }

  return value;
};

export const formatDashboardOrdiniFilters = (filters = {}, campiRicerca = []) => {
  const fieldMap = getFieldMap(campiRicerca);
  const parts = [];

  Object.entries(filters || {}).forEach(([key, value]) => {
    if (key === "mongoFilters" && value && typeof value === "object") {
      Object.entries(value).forEach(([mongoKey, mongoValue]) => {
        if (!Array.isArray(mongoValue) || mongoValue.length === 0) {
          return;
        }
        const isNotIn = mongoKey.endsWith("_not_in");
        const baseKey = mongoKey.replace(/_(in|not_in)$/, "");
        const labelBase = MONGO_FILTER_LABELS[baseKey] ?? baseKey;
        parts.push(
          `${labelBase} (${isNotIn ? "NOT IN" : "IN"}): ${mongoValue.join(", ")}`,
        );
      });
      return;
    }

    if (value === undefined || value === null || value === "") {
      return;
    }

    const field = fieldMap.get(key);
    const label = field?.labelCorta || field?.label || cleanFilterKey(key);
    const formattedValue = formatFieldValue(field, value);

    if (!formattedValue) {
      return;
    }

    parts.push(`${label}: ${formattedValue}`);
  });

  return parts.length ? parts.join(", ") : "Tutto";
};

export const dashboardOrdiniSectionCaptions = {
  ordini_in_corso:
    "Include solo ordini non ancora spediti negli stati operativi di preparazione. Esclude le attese dal blocco principale, ma il grafico stati mostra anche IN ATTESA / IN ATTESA BB; i conteggi ordine usano il riferimento marketplace valorizzato.",
  statOrdini:
    "Le statistiche ordine usano Spedizioni filtrate per Data_partenza nel range scelto. Per i riepiloghi principali include solo Stato_Ordine = SPEDITO ed esclude Tipo in Servizio interno, Reso, Nuova spedizione e Invio per sostituzione; gli importi escludono le righe gia scontrinate.",
  incassiSpedizioni:
    "Somma Spedizioni.Spese_di_spedizione e Spedizioni.Spese_di_contrassegno per Data_partenza nel periodo. Include solo SPEDITO, esclude i tipi interni/resi/sostituzioni e le righe gia scontrinate; raggruppa per marketplace e paese cliente.",
  statArticoli:
    "Include solo articoli collegati a spedizioni SPEDITO nel range scelto, con codice VS valorizzato e join su MODA_Articoli. Le pie raggruppano per attributi MODA; le top list raggruppano per codice VS e sommano quantita o importo unitario x quantita.",
  trend_reparti:
    "Trend mensile sugli ultimi N anni costruito da Articoli -> Sped/Art -> Spedizioni -> MODA_Articoli. Include solo spedizioni SPEDITO con codice VS valorizzato; mostra i 10 reparti piu rilevanti nel periodo.",
  trend_categorie:
    "Trend mensile sugli ultimi N anni costruito da Articoli -> Sped/Art -> Spedizioni -> MODA_Articoli. Include solo spedizioni SPEDITO con codice VS valorizzato; mostra le 10 categorie piu rilevanti nel periodo.",
  trend_tipi:
    "Trend mensile sugli ultimi N anni costruito da Articoli -> Sped/Art -> Spedizioni -> MODA_Articoli. Include solo spedizioni SPEDITO con codice VS valorizzato; mostra i 10 tipi piu rilevanti nel periodo.",
  storico:
    "Serie giornaliera per Data_partenza. Esclude Servizio interno, Reso, Nuova spedizione e Invio per sostituzione; i conteggi ordine usano il riferimento marketplace distinto e gli importi escludono Emissione_scontrino NO - GIA' SCONTRINATO e NO - FATTURATO IN SPLIT.",
  spedAnni:
    "Confronto mensile per anno sulla tabella Spedizioni. Lavora su Data_partenza, esclude il mese corrente e i tipi interni/resi/sostituzioni; in modalita ordini conta riferimenti marketplace distinti, in modalita importo somma i totali ordine al netto dei gia scontrinati.",
  spedMarket:
    "Confronto mensile per marketplace sugli ultimi N anni, basato su Data_partenza. Esclude il mese corrente e i tipi interni/resi/sostituzioni; distingue marketplace noti e raccoglie il resto in Altri.",
  spedCorrieri:
    "Confronto mensile per corriere su Data_partenza. I conteggi usano ordini distinti per riferimento marketplace; puoi includere o escludere spedizioni di servizio, mentre ritiro negozio non entra nelle serie principali e gli altri corrieri confluiscono in Altri.",
  spedizioni_paesi:
    "Mostra il top 10 paesi per periodo mobile sugli ultimi N anni, raggruppando per Paese di provenienza cliente. Esclude il mese corrente e i tipi interni/resi/sostituzioni; il toggle canale limita a Amazon, PrestaShop - vs.com o tutti.",
  motivi_annullamenti:
    "Trend mensile per causale stato basato sulla data ordine (`sped.Data`), non su Data_partenza. Esclude Ordine di test e i tipi interni/resi/sostituzioni; di default considera solo Stato_Ordine = ANNULLATO, ma il toggle puo estenderlo a tutti gli ordini.",
  grane:
    "Trend storico delle grane marketplace/corriere secondo il componente statistiche dedicato. La logica di inclusione dipende dalle causali e dai flag presenti su Spedizioni nel backend del grafico.",
  dati_grane:
    "Riepilogo analitico delle grane corrieri prodotto dall'endpoint contabile dedicato. Le inclusioni ed esclusioni seguono le causali e i controlli di allineamento fatture definiti lato backend.",
  controllo_fatture_corrieri:
    "Controllo di coerenza tra spedizioni e fatture corrieri costruito dall'endpoint contabile dedicato. Il contenuto e una vista di controllo, non un totale amministrativo puro, quindi va letto come riconciliazione operativa.",
  dati_condivisi:
    "Include articoli con flag `a.inv_sharing = 1` o `a.dropshipping = 1` nel range scelto. Qui il filtro data usa `sped.Data` e non `Data_partenza`; i grafici raggruppano per stato ordine e attributi articolo, mentre le top list sono per codice VS.",
  trend_condivisi:
    "Trend mensile sugli ultimi N anni con due viste. 'Sharing sul totale' confronta venduto condiviso, vendite generali e incidenza percentuale; 'Sharing per brand' mostra una linea per ogni `a.Produttore` presente nel venduto condiviso. Usa `sped.Data_partenza`, non filtra per stato ordine e richiede almeno EAN o codice VS valorizzato; la vista brand richiede anche `a.Produttore` valorizzato.",
  confronta_trend_ordini:
    "Ogni linea applica i filtri della ricerca avanzata ordine e poi aggrega per mese su `sped.Data_partenza` negli ultimi N anni. In quantita conta `COUNT(DISTINCT sped.ID Spedizione)`; in importo somma `sped.Tot_imp_spedizione` escludendo i gia scontrinati. Con filtri su articoli/MODA l'importo resta una vista operativa e puo risentire del join ordine-articoli.",
  confronta_trend_articoli:
    "Ogni linea applica i filtri della ricerca avanzata articoli e aggrega per mese su `sped.Data_partenza` negli ultimi N anni. In quantita somma `a.Quantita`; in importo somma `a.Quantita * a.Importo unitario`. Il canale filtra `sped.Canale`; eventuali filtri Mongo vengono risolti lato backend sui codici VS.",
  confronta_dati:
    "Usa i filtri della ricerca avanzata logistica e calcola un riepilogo misto ordine/articolo. Gli stati contano spedizioni distinte; reparti, categorie, brand e top list derivano dal join Spedizioni -> Sped/Art -> Articoli -> MODA_Articoli e le top raggruppano per codice VS / ID articolo.",
};
